<template>
  <div class="image-composition-content">
    <div
      v-for="img in imgs"
      :key="img.url"
      class="image-card"
      :class="{
        'default-card': img.url === defaultUrl,
        active: img.url === activeUrl,
      }"
    >
      <div
        class="absolute right-[24px] top-[20px] leading-[24px] px-[13px] rounded-[12px] bg-back-0 text-[12px]"
      >
        {{ img.name }}
      </div>
      <a-button
        class="absolute pc-only bottom-[30px] left-1/2 -translate-x-1/2 edit-btn font-[500]"
        type="primary"
        shape="round"
        @click="edit(img)"
      >
        {{ $t('bian-ji') }}
      </a-button>
      <Resource
        class="w-full h-full bg-back-3 rounded-[4px] overflow-hidden object-contain"
        :src="img.url"
        :resource-option="{
          format: 'webp',
          resize: {
            w: 1000,
            m: 'lfit',
          },
        }"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type {
  CharacterCollection,
  Character,
  CharacterXihe,
} from '~/api/interface/character'

import { ACTOR_NAV, CONFIG_NAV } from '~/constants'
import { createWorkByCharacter } from '~/features/createWork/utils'
interface ImageCompositionProps {
  character?: Character | null
  characterXihe?: CharacterXihe
}

const props = defineProps<ImageCompositionProps>()

const { $t } = useNuxtApp()

const activeUrl = ref('')

function getCollection(
  data: CharacterCollection[] | undefined,
  type: CharacterCollection['type']
) {
  const res = data?.find((item) => item.type === type)
  if (res && type === 'makeup_collection') {
    return res?.is_general?.TRUE ? res : undefined
  }
  return res
}

interface ImgType {
  url: string
  name: string
  navKey: ACTOR_NAV | string
}

const imgs = computed(() => {
  const _imgs: ImgType[] = []

  const hairCollection = getCollection(
    props.characterXihe?.collection_list,
    'hair_collection'
  )

  if (hairCollection?.render_image_oss_pro) {
    _imgs.push({
      url: hairCollection.render_image_oss_pro,
      name: $t('fa-xing'),
      navKey: ACTOR_NAV.HAIR,
    })
  }

  if (props.character?.cover_url) {
    _imgs.push({
      url: props.character.cover_url,
      name: $t('ren-wu'),
      navKey: ACTOR_NAV.CHARACTER,
    })
  }

  const collection = getCollection(
    props.characterXihe?.collection_list,
    'collection'
  )

  if (collection?.render_image_oss_pro) {
    // 套装
    _imgs.push({
      url: collection.render_image_oss_pro || '',
      name: $t('tao-zhuang'),
      navKey: ACTOR_NAV.COLLECTION,
    })
  }

  if (props.characterXihe?.accessory_info) {
    props.characterXihe.accessory_info
      .filter((item) =>
        ['Stud', 'Eardrop', 'Earrings', 'Glasses'].includes(
          item.spu__category__name
        )
      )
      .slice(0, 2)
      .forEach((item) => {
        _imgs.push({
          url: item.render_image_oss_pro || '',
          name: item.spu__category__cn_name,
          navKey: `${ACTOR_NAV.ACCESSORY}-${item.spu__category__name}-${item.id}`,
        })
      })
  }

  const makeupCollection = getCollection(
    props.characterXihe?.collection_list,
    'makeup_collection'
  )

  if (makeupCollection?.render_image_oss_pro) {
    _imgs.push({
      url: makeupCollection.render_image_oss_pro,
      name: $t('zhuang-rong'),
      navKey: ACTOR_NAV.MAKEUP,
    })
  }

  return _imgs
})

let defaultUrl = ''
watchEffect(() => {
  defaultUrl = props.character?.cover_url || ''
  activeUrl.value = props.character?.cover_url || ''
})

function edit(img: ImgType) {
  createWorkByCharacter(props.character!.id, CONFIG_NAV.ACTOR, img.navKey)
}
</script>
<style lang="scss" scoped></style>
